<template>
  <div class="platform-info-edit-wrp ft-12">
    <el-form
      class="form"
      :model="self_form"
      :rules="rules"
      ref="form"
      label-width="12%"
    >
      <slot name="errMsg"></slot>
      <section>
        <div class="title ft-12">
          <span>商品类型</span>
        </div>
        <div class="conf">
          <el-form-item label="商品类型:" prop="itemType">
            <div class="ft-12">
              <el-radio-group v-model="self_form.itemType">
                <el-radio
                  v-for="op in itemTypeOptions"
                  :key="op.value"
                  :label="op.value"
                  border
                >
                  {{ op.label }}</el-radio
                >
              </el-radio-group>
            </div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>基本信息</span>
        </div>
        <div class="conf">
          <el-form-item label="商品类目:" prop="categoryIds">
            <div class="category ft-12">
              <category-input
                ref="cinput"
                v-model="self_form.categoryIds"
                :baseItemId="baseItemId" 
                :platform="platform"
              />
            </div>
            <div class="tips ft-12">
              <span
                >商品类目及类目细项，<a
                  href="https://bbs.youzan.com/forum.php?mod=viewthread&tid=25252"
                  target="_blank"
                  >点此查看</a
                ></span
              >
            </div>
          </el-form-item>
          <el-form-item label="类目参数:">
            <CategoryProps
              ref="cateprops"
              v-model="self_form.attributes"
              :categoryIds="self_form.categoryIds"/>
          </el-form-item>
          <el-form-item label="商品名" prop="title">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.title"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="分享描述" prop="summary">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.summary"
            >
            </el-input>
            <div class="tips ft-12">
              <span>微信分享给好友时会显示，建议36个字以内</span>
            </div>
          </el-form-item>
          <el-form-item label="商品卖点" prop="sellPoint">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.sellPoint"
            >
            </el-input>
            <div class="tips ft-12">
              <span>在商品详情页标题下面展示卖点信息，建议60字以内</span>
            </div>
          </el-form-item>
          <el-form-item label="引用套图:" v-if="showGroupImages">
            <div class="ft-12">商品资料已维护套图，电商平台图片可以使用已维护套图快速填充 <el-link @click="editGroupImages">维护套图</el-link> </div>
            <GroupImagesList :baseItemId="baseItemId" :hideImgs="['detailImages', 'mainImages34']" :specifications="specifications" @useOk="useGroupImages" @getList="getGroupImagesList"></GroupImagesList>
          </el-form-item>
          <el-form-item label="商品图" prop="images">
            <div class="imgs-wrp">
              <div class="ft-12">铺货时只取主图，拖动可调整顺序<BatchEditImages v-model="self_form.images" refName="images" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
              <MutiImgUpload
                ref="images"
                v-model="self_form.images"
                :limitNums="50"
                :size="300"
                :mainImgNums="0"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <p class="tips ft-12">
              建议尺寸：800*800像素，支持批量传图，最多上传50张图片
            </p>
          </el-form-item>
          <template v-if="retailShopList && retailShopList.length > 0" >
            <div class="retail-wrapper">
              <div class="label-wrap el-form-item__label">
                <span style="color: #F56C6C;margin-right: 4px;">*</span>
                商品分类
              </div>
              <div class="form-wrap">
                <template v-for="(shop, index) in retailShopList">
                  <el-form-item
                    :key="index"
                    :prop="`shopCategoryMap.${shop.userId}.categoryId`"
                    label-width="0"
                    :rules="[{ required: true, message: '有赞零售店铺必须选择商品分类'}]"
                  >
                    <div class="shop-wrap">
                      <el-image
                        :src="shop.icon"
                        style="width: 26px; height: 26px; border-radius: 50%"
                      ></el-image>
                      <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
                        <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
                      </el-tooltip>
                      <span class="shop-title" :title="shop.title">{{ shop.shortTitle || shop.title }}</span>
                    </div>
                    <div class="category-wrap">
                      <template v-if="self_form.shopCategoryMap[shop.userId] && self_form.shopCategoryMap[shop.userId].categoryId">
                        <el-button type="link" @click="handleSelectRetailShopCategory(shop)">
                          {{ self_form.shopCategoryMap[shop.userId].categoryName }}
                        </el-button>
                      </template>
                      <template v-else>
                        <el-button type="link" @click="handleSelectRetailShopCategory(shop)">选择类目</el-button>
                      </template>
                    </div>
                  </el-form-item>
                </template>
              </div>
            </div>
            <!-- <el-form-item label="商品分类">
              <el-link style="margin:0 10px;"  href="https://www.youzan.com/v4/goods/tag/index#/create" target="_blank">新建分类</el-link>
              <el-link href="https://bbs.youzan.com/forum.php?mod=viewthread&tid=15" target="_blank">如何创建商品分类？</el-link>
            </el-form-item> -->
          </template>

        </div>
      </section>
      <section>
        <div class="title">
          <span>规格与库存</span>
        </div>
        <div class="conf">
          <el-form-item label="商品规格:" prop="skuAttrs">
            <RuleSortBtn :specifications.sync="specifications" />
            <SpecsValuesSort :specifications.sync="specifications" />
            <FormItemSpecification
              :pureType="isPureType"
              v-model="specifications"
              :changeToBase="changeToBase"
              :platform="platform"
              :isPlatform="true"
              :imgLimits="specImgLimits"
              imgLimitSuffix=".jpg,.png,.jpeg"
            />
          </el-form-item>
          <el-form-item label="规格明细:" prop="skuAttrsDetail">
            <FormItemSkuList
              :pureType="isPureType"
              :specifications="specifications"
              :baseItemId="baseItemId"
              :imgOnlyPreview="skuImgOnlyPreview"
              :tableCols="skuTableCols"
              @skuFieldBlur="handleSkuFieldBlur"
              @batchUpdate="handleBatchUpdate"
              v-model="skuList"
              @fieldChanged="validPage"
            />
            <template v-if="specificationsValidResult !== true">
              <div class="el-form-item__error">{{specificationsValidResult}}</div>
            </template>
          </el-form-item>
          <el-form-item label="价格:" prop="price">
            <el-input-number
              class="number-input"
              style="width: 120px"
              :disabled="!isPureType"
              v-model.number="self_form.price"
              :controls="false"
              :precision="2"
            />
          </el-form-item>
          <el-form-item label="划线价:" prop="origin">
            <el-input-number
              class="number-input"
              style="width: 120px"
              v-model.number="self_form.origin"
              :controls="false"
              :precision="2"
            />
          </el-form-item>
          <el-form-item label="库存:" prop="quantity">
            <el-input-number
              class="number-input"
              style="width: 120px"
              :disabled="!isPureType"
              v-model.number="self_form.quantity"
              :controls="false"
              :precision="0"
            />
            <div class="tips ft-12">
              <span
                >库存为0时，会放到【已售罄】的商品列表里，保存后买家看到的商品可售库存同步更新</span
              >
            </div>
          </el-form-item>
          <el-form-item label="重量:" prop="weight">
            <el-input-number
              class="number-input"
              style="width: 120px"
              v-model.number="self_form.weight"
              :controls="false"
              :precision="3"
            />kg
          </el-form-item>
          <el-form-item label="库存扣减方式:" prop="stockDeductMode">
            <el-radio v-model="self_form.stockDeductMode" :label="0">拍下减库存</el-radio>
            <div class="tips ft-12">
              <span
                >购买者拍下商品，扣减商品库存，可能存在<a href="https://help.youzan.com/displaylist/detail_4_4-2-26701" target="_blank">恶意占用库存风险</a>商品参加“多人拼图”、“降价拍”活动时，默认为付款减库存。</span
              >
            </div>
            <el-radio :disabled="self_form.preSaleType && self_form.presaleParam.pre_sale_type === 1" v-model="self_form.stockDeductMode" :label="1">付款减库存</el-radio>
            <div class="tips ft-12">
              <span
                >购买者付款成功时，扣减商品库存；定金预售时此项不可选</span
              >
            </div>
          </el-form-item>
          <el-form-item label="会员折扣:" prop="joinLevelDiscount">
            <el-checkbox
              :disabled="self_form.preSaleType && self_form.presaleParam.pre_sale_type === 1"
              v-model="self_form.joinLevelDiscount"
              >参加会员折扣</el-checkbox
            >
            <div class="tips ft-12">
              <span
                >定金预售时将不能参与会员折扣</span
              >
            </div>
          </el-form-item>
          <el-form-item label="商品编码:" prop="outerId">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.outerId"
            >
            </el-input>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title">
          <span>物流信息</span>
        </div>
        <div class="conf">
          <el-form-item label="配送方式:" prop="deliverMethods">
            <el-checkbox-group v-model="self_form.deliverMethods">
              <el-checkbox
                v-for="op in deliverMethodsOptions"
                :key="op.value"
                :label="op.value"
                >{{ op.label }}</el-checkbox
              >
              <div
                v-if="
                  self_form.deliverMethods &&
                  self_form.deliverMethods.includes('selfPick')
                "
                style="font-size: 12px;"
              >
                “到店自提”需在店铺设置开启后生效
              </div>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            v-if="
              self_form.deliverMethods &&
              self_form.deliverMethods.includes('express')
            "
            label="快递运费:"
            prop="postage"
          >
            <el-input-number
              class="number-input"
              style="width: 120px"
              v-model.number="self_form.postage"
              :controls="false"
              :precision="2"
            ></el-input-number>
            <div class="tips ft-12">
              若没设置运费模板，请填写快递运费，否则会导致铺货异常
            </div>
          </el-form-item>
        </div>
      </section>

      <section>
        <div class="title">
          <span>其他设置</span>
        </div>
        <div class="conf">
          <el-form-item label="上架时间:" prop="display">
            <el-radio-group class="flex-column pt-5" v-model="self_form.display">
              <el-radio :label="1">立即上架售卖</el-radio>
              <el-radio :label="2">
                自定义上架时间
                <el-date-picker
                  v-model="self_form.autoListingTime"
                  :disabled="self_form.display !== 2"
                  width="250px"
                  type="datetime"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
              </el-radio>
              <el-radio :label="0">备暂不售卖，放入仓库</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否预售:" prop="preSaleType">
            <el-checkbox v-model="self_form.preSaleType">下单后需要过段时间才能发货</el-checkbox>
            <div v-if="self_form.preSaleType">
              <el-radio v-model="self_form.presaleParam.pre_sale_type" :label="0">全款预售</el-radio>
              <el-radio v-model="self_form.presaleParam.pre_sale_type" :disabled="self_form.joinLevelDiscount || self_form.stockDeductMode === 1" :label="1">定金预售</el-radio>
              <div class="tips ft-12">
                <span
                  >参与会员折扣或付款减库存时定金预售不可用</span
                >
              </div>
            </div>
          </el-form-item>
          <template v-if="self_form.presaleParam.pre_sale_type === 1">
            <el-form-item label="定金尾款设置:" prop="pre_sale_range">
              <div class="ft-12 mb-5">
                定金支付时间 <el-date-picker
                  v-model="self_form.pre_sale_range"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
              <div class="ft-12 ">
                尾款支付时间 <el-date-picker
                  v-model="self_form.balance_due_range"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="定金收取方式:" prop="presaleParam.deposit_type">
              <div class="flex-column">
                <el-radio v-model="self_form.presaleParam.deposit_type" :label="0">
                  按比例
                  <el-select
                    :disabled="self_form.presaleParam.deposit_type !== 0"
                    v-model="self_form.presaleParam.deposit_ratio"
                    placeholder="请选择">
                    <el-option
                      v-for="(num) in [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]"
                      :key="num"
                      :value="num"
                      :label="`${num}%`"
                      ></el-option>
                  </el-select>
                  收取
                </el-radio>
                <el-radio v-model="self_form.presaleParam.deposit_type" :label="1">
                  按金额
                  <el-input-number
                    :disabled="self_form.presaleParam.deposit_type !== 1"
                    class="number-input"
                    style="width: 120px"
                    :max="self_form.price - 1"
                    :min="1"
                    :controls="false"
                    :precision="2"
                    v-model="self_form.presaleParam.deposit"></el-input-number>
                  元收取
                </el-radio>
              </div>
            </el-form-item>
          </template>
          <el-form-item
            v-if="[0,1].includes(self_form.presaleParam.pre_sale_type)"
            label="发货时间:" prop="presaleParam.etd_type">
            <div class="flex-column">
              <el-radio v-model="self_form.presaleParam.etd_type" :label="0">
                <el-date-picker
                  :disabled="self_form.presaleParam.etd_type !== 0"
                  width="250px"
                  v-model="self_form.presaleParam.etd_start"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
                开始发货
              </el-radio>
              <el-radio v-model="self_form.presaleParam.etd_type" :label="1">
                {{ self_form.presaleParam.pre_sale_type === 0 ? '付款成功' : '尾款支付'}}
                <el-input-number
                  :disabled="self_form.presaleParam.etd_type !== 1"
                  class="number-input"
                  style="width: 120px"
                  :controls="false"
                  :precision="0"
                  :max="90"
                  v-model="self_form.presaleParam.etd_days"></el-input-number>
                天后发货
              </el-radio>
            </div>
          </el-form-item>

          <el-form-item
            :class="editorFormItenClass"
            label="商品详情:"
            prop="itemDesc"
          >
            <Editor
              id="pc"
              v-model="self_form.itemDesc"
              @fullScreenChange="editorFullScreenChange"
            />
          </el-form-item>
        </div>
      </section>
      <!-- 运费模板 -->
      <section>
        <div class="title ft-12">
          <span>运费模板</span>
        </div>
        <div class="conf">
          <el-form-item label="运费设置：">
            <el-row v-if="shopList.length > 0">
              <el-col
                v-for="shop in shopList"
                :key="shop.id"
                :span="12"
                class="set-ship"
              >
                <el-image
                  :src="shop.icon"
                  style="width: 26px; height: 26px; border-radius: 50%"
                ></el-image>
                <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
                  <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
                </el-tooltip>
                <span class="shop-title">{{ shop.shortTitle || shop.title }}</span>
                <el-select
                  v-model="shipsValue[shop.id]"
                  placeholder="请选择运费模板"
                  :value-key="String(shop.id)"
                  clearable
                  @clear="changeSelect(shop.id, shop.userId)"
                  @visible-change="changeSelect(shop.id, shop.userId)"
                >
                  <el-option
                    v-for="ship in shipsTemplate[shop.id]"
                    :key="ship.id"
                    :label="ship.name"
                    :value="ship.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <span v-else class="no-shops">暂无平台店铺</span>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>服务承诺</span>
        </div>
        <div class="conf">
          <el-form-item style="margin-bottom: 0px">
            <el-checkbox
              v-model="self_form.isSupportBarter"
            >支持买家申请换货</el-checkbox>
          </el-form-item>
          <el-form-item style="margin-bottom: 0px">
            <el-checkbox
              v-model="self_form.supportUnconditionalReturn"
            >7天无理由退货</el-checkbox>
          </el-form-item>
        </div>
      </section>
    </el-form>
    <!-- 有赞零售店铺选择类目 -->
    <SelectRetailShopCategoryDialog
      ref="selectRetailShopCategoryDialog"
      @on-confirm="handleSelectRetailShopCategoryCallback"
    />
  </div>
</template>
<script>
import "@/assets/css/prod.scss";
import MutiImgUpload from "@/components/Uploads/MutiImgUpload";
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue'
import CategoryProps from "./CategoryProps.vue";
import CategoryInput from "../PlatformCategoryInput/index.vue";
import ReuseLastCategory from "../PlatformCategoryInput/ReuseLastCategory.vue";

import RULES, { validateSkuStock, validateSkuWeight } from "./rules.js";
import { validateSkuPrice } from "../DdianInfoForm/rules";

import { specification_mixin } from "../FormItemSpecification";
import { editor_mixin } from "@/components/Editor/index.js";
import { itemTypeOptions, deliverMethodsOptions } from "./dictionary";
import {
  getYouZanTemplates,
} from "@servers/prod/conf/index.js";
import { mapGetters } from "vuex";
import { cloneDeep, keyBy, unionBy } from 'lodash';
import SelectRetailShopCategoryDialog from "./SelectRetailShopCategoryDialog.vue";
import validateMixin from '../validateMixin';
import shopListMixin from '../shopListMixin';

export default {
  mixins: [specification_mixin, editor_mixin, validateMixin,shopListMixin],
  provide: {
    platform: "yz",
  },
  inject: {
    isGroupPuhuo: {
      default: false,
    },
    selectShopList: {
      default: () => [],
    },
  },
  components: {
    MutiImgUpload,
    BatchEditImages,
    GroupImagesList,
    CategoryInput,
    CategoryProps,
    ReuseLastCategory,
    SelectRetailShopCategoryDialog
  },
  props: {
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    shopsList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    baseItemId: [Number, String],
    changeToBase: Function,
    rowData: {
      type: Object,
      default: () => ({})
    },
    openSource:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      platform: "yz",
      self_form: {
        presaleParam: {
          pre_sale_type: undefined
        }
      },
      rules: RULES(this),
      skuTableCols: [],
      showGroupImages: true,
      skuSpecificationsKey: "skuSpecifications",
      itemTypeOptions,
      deliverMethodsOptions,
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      specification_needImg: true, // 规格需要校验图片是否补充
      shipsTemplate: null, // 运费模板列表
      shipsValue: null, // 运费模板值
      templateConfigMap: null, // 初始值
      originalTemplateConfig: null,
      shopList: [],
      retailShopList: [], // 有赞零售店铺列表
      retailShopId: null, // 选择操作的有赞零售店铺
      specImgLimits: {
          limitWidth: [0, 800],
          limitHeight: [0, 800],
          limitSuffix: '.png,.jpg,.jpeg'
      },
    };
  },
  watch: {
    form: {
      handler(v) {
        if (v.templateConfig && v.templateConfig.length) {
            this.originalTemplateConfig = cloneDeep(v.templateConfig);
        }
        if (v.skuList) {
          v.skuList = v.skuList.map((item) => {
            const _skuid = item[this.skuSpecificationsKey]
              .map((sp) => sp.valueKey)
              .join("-");
            return {
              ...item,
              _skuid,
            };
          });
        }
        const valuation_type = 2 //按重量必填 1.按件 2 按重量 3 按体积
        let valuationType = v.templateConfig && v.templateConfig.length 
                              ? v.templateConfig.find(item => item.valuationType === valuation_type)?.valuationType 
                              : undefined;
        if(v.templateConfig.length === 0 || (valuationType !== valuation_type)){

          const rules = Object.assign({},RULES(this))
          const filterRules = Object.keys(rules).reduce((acc,key)=>{
            if(key !='weight'){
              acc[key] = rules[key]
            }
            return acc
          },{})
          this.rules = filterRules
        }
        if (v.specifications && v.specifications.length) {
          this.specifications = JSON.parse(JSON.stringify(v.specifications));
        }
        const { shopCategoryList = [] } = v;
        let _form = {
          ...v,
          shopCategoryMap: keyBy(shopCategoryList, 'userId'),
          isSupportBarter: v.isSupportBarter || false,
          supportUnconditionalReturn: v.supportUnconditionalReturn || false,
        }
        this.$set(this, 'self_form', _form)
        this.$nextTick(() => {
          this.getConf();
          this.validPage();
          // this.$refs.form.validate()
        })
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["shops_getCategoryPropShopId", "get_AllShops_BySource"]),
    isPureType() {
      return this.form?.pureType
    },
  },
  methods: {
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : []
    },
    setLowPrice() {
      let lowPrice = undefined
      this.skuList.forEach(sku => {
        if (isNaN(Number(sku.skuPrice))) {
          return ;
        }

        if (lowPrice === undefined) {
          lowPrice = sku.skuPrice
        } else {
          lowPrice = lowPrice > sku.skuPrice ? sku.skuPrice : lowPrice
        }
      })
      this.self_form.price = lowPrice
    },
    setTotalStock() {
      let totalStock = this.skuList.reduce((total, sku) => {
        total += (isNaN(Number(sku.stockNum)) ? 0 : Number(sku.stockNum))
        return total
      }, 0)
      this.self_form.quantity = totalStock
    },
    handleSkuFieldBlur(field) {
      if (field === 'skuPrice') {
        this.setLowPrice()
      } else if (field === 'stockNum') {
        this.setTotalStock()
      }
    },
    handleBatchUpdate() {
      this.setLowPrice();
      this.setTotalStock();
    },
    // 将nameKey与valueKey转为数字型
    convertNameKeyValueKey(specifications, skuList) {
      let number = 1;
      let nameKeyConvertArr = [[],[],[]]; 
      let valueKeyConvertArr = [[],[],[]]; 
      let nameKeyConvertMap = {0:{}, 1: {}, 2: {}};
      let valueKeyConvertMap= {0:{}, 1: {}, 2: {}};

      specifications.forEach((sp, spi) => {
        if (isNaN(Number(sp.nameKey))) {
          nameKeyConvertArr[spi].push(sp.nameKey)
          nameKeyConvertMap[spi][sp.nameKey] = number;
          sp.nameKey = number;
          number++;
        }
        sp.values && sp.values.forEach(spv => {
          if (isNaN(Number(spv.valueKey))) {
            valueKeyConvertArr[spi].push(spv.valueKey)
            valueKeyConvertMap[spi][spv.valueKey] = number;
            spv.valueKey = number;
            number++;
          }
        })
      })

      skuList.forEach(sku => {
        sku.skuSpecifications.forEach((skusp, skuspi) => {
          if (skuspi > 0) {
            delete skusp.imageUrl
          }

          if (nameKeyConvertArr[skuspi].includes(skusp.nameKey)) {
            skusp.nameKey = nameKeyConvertMap[skuspi][skusp.nameKey]
          }
          if (valueKeyConvertArr[skuspi].includes(skusp.valueKey)) {
            skusp.valueKey = valueKeyConvertMap[skuspi][skusp.valueKey]
          }
        })
      })

    },

    method_getFormData(cb) {
      return new Promise((resolve, reject) => {
        this.validPage().then((valid) => {
          if (!valid) {
            this.$message.error("请完善类目属性");
            resolve(false);
            return;
          }
          const [specifications, skuList] = this.getSpecificationData();
          const c_names = this.$refs.cinput.method_getCategoryNames();
          let _formdata = cloneDeep(this.self_form);
          _formdata.specifications = JSON.parse(
            JSON.stringify(specifications)
          );
          _formdata.skuList = skuList.map((item) => ({
            ...item,
            imageUrl: item[this.skuSpecificationsKey][0].imageUrl,
          }));
          // 处理有赞零售店铺分类关闭绑定数据
          _formdata.shopCategoryList = this.formatShopCategoryList(_formdata);
          delete _formdata['shopCategoryMap'];
          _formdata.categoryId =
            _formdata.categoryIds[_formdata.categoryIds.length - 1];
          _formdata.category_names = c_names;
          _formdata.templateConfig = (() => {
              let current = JSON.parse(this.handleTemplateConfig());
              current = this.mergeHiddenShopData(current, this.originalTemplateConfig, this.shopList);
              return JSON.stringify(current);
          })();
          _formdata.shopId =
            this.shops_getCategoryPropShopId("yz") || 151987;
          this.convertNameKeyValueKey(_formdata.specifications, _formdata.skuList)
          resolve(_formdata);
        });
      });
    },
    formatShopCategoryList(formData) {
      const { shopCategoryMap } = formData;
      const shopCategoryList = formData.shopCategoryList || []
      const retailShopList = cloneDeep(this.retailShopList);
      // shopCategoryList 是记录里保存过的 有赞零售店铺与分类的绑定信息
      // retailShopList 为当前查询到的有赞零售店铺列表
      // 但是可能会存在「新增的店铺/店铺数据被删除/服务到期」等所导致的 retailShopList 与 shopCategoryList 不匹配
      // 先进行数组合并&去重处理，
      // 如果店铺数据被删除/服务到期，也依旧能够读取到shopCategoryMap保存的配置
      // 新增的数据，会通过shopCategoryMap匹配进行覆盖
      const unionList = unionBy([...shopCategoryList, ...retailShopList], 'userId');
      const newList = unionList.map(item => {
        const { userId } = item;
        const matchData = shopCategoryMap[userId];
        return matchData;
      })
      return newList;
    },
    handleTemplateConfig() {
      const arr = [];
      Object.keys(this.shipsValue).forEach((key) => {
        this.shipsTemplate[key].forEach((item) => {
          if (item.id == this.shipsValue[key]) {
            const channel = this.shopList.find(shop => shop.id == key)?.channel
            arr.push({
              shopId: key,
              templateId: item.id,
              templateName: item.name,
              channel,
              valuationType: item.valuationType,
            });
          }
        });
      });
      return JSON.stringify(arr);
    },
    // 处理有赞详情 templateConfig
    initTemplateConfig(templateList = []) {
      const ships = {};
      this.shopList.forEach((shop) => {
        ships[shop.id] = "";
      });
      const templateConfigMap = {};
      this.self_form.templateConfig = this.self_form.templateConfig
        ? this.self_form.templateConfig
        : [];
      this.self_form.templateConfig.forEach((item) => {
        templateConfigMap[item.shopId] = {
          templateId: item.templateId,
          templateName: item.templateName,
        };
      });
      templateList.forEach((item) => {
        if (!templateConfigMap[item.shopId]) {
          templateConfigMap[item.shopId] = {
            templateId: item.templateId,
            templateName: item.templateName,
          };
        }
      });
      this.templateConfigMap = templateConfigMap;
      Object.keys(templateConfigMap).forEach((key) => {
        ships[key] = templateConfigMap[key].templateId;
      });
      this.shipsValue = ships;
      this.initShipsTemplate(templateConfigMap);
    },
    // 处理每个店铺下拉框
    initShipsTemplate(templateConfigMap) {
      const shipsTemplate = {};
      this.shopList.forEach((shop) => {
        shipsTemplate[shop.id] = [];
      });
      Object.keys(templateConfigMap).forEach((key) => {
        shipsTemplate[key] = [
          {
            id: templateConfigMap[key].templateId || "",
            name: templateConfigMap[key].templateName || "",
          },
        ];
      });
      this.shipsTemplate = shipsTemplate;
    },
    // 获取配置
    async getConf() {
      // const res = await getDistributionConfig({ shopType: "KWaiShop" });
      if (this.isGroupPuhuo) {
        this.shopList = this.shopsList;
      } else {
        const selectList = this.selectShopList();
        if(selectList && selectList.length) {
          this.shopList = selectList.filter(item => item.source === 'yz');
        } else {
          const shopList = this.get_AllShops_BySource('yz');
          // 如果是重新铺货或者已经有对应的店铺进来，直接显示对应的店铺
          if(this.rowData.isFromLog) {
            this.shopList = shopList.filter(item => item.id == this.rowData.shopId);
          }else{
            this.shopList = shopList;
          }
        }
      }
      if(this.openSource === 'shopGoods'){
          this.shopList = this.shopList.filter(item => item.id == this.form.shopId)
      }
      // 判断是否有零售店铺
      const shopList = cloneDeep(this.shopList);
      const retailShopList = shopList.filter(item => {
        return item.youzanType === '70000';
      });
      // 初始化零售店铺数据
      const { shopCategoryMap } = this.self_form;
      retailShopList.forEach(item => {
        const { userId } = item;
        if (!shopCategoryMap[userId]) {
        this.$set(shopCategoryMap, userId, {
          userId,
          categoryId: null,
          categoryName: null,
        })
      }
      })
      this.retailShopList = retailShopList;
      // 运费模板
      // this.initTemplateConfig(res?.templateList || []);
      this.initTemplateConfig([]);
    },
    // 获取模板
    async getTemplateList(userId) {
      const list = await getYouZanTemplates({
        userId: userId,
      });
      if (list) {
        return list.map((ship) => {
          return {
            name: ship.name,
            id: ship.id.toString(),
            valuationType: ship.valuationType,
          };
        });
      }
      return [];
    },
    async changeSelect(shopId, userId) {
      const list = await this.getTemplateList(userId);
      const valuation_type = 2 //按重量必填 1.按件 2 按重量 3 按体积
      const idx = list.findIndex((item) => item.id === this.shipsValue[shopId]);
      const shipArrTemp = JSON.parse(this.handleTemplateConfig()) || []
      let valuationType = shipArrTemp && shipArrTemp.length 
                          ? shipArrTemp.find(item => item.valuationType === valuation_type)?.valuationType 
                          : '';
      if (idx === -1) {
        this.shipsValue[shopId] = "";
      }
      if(valuationType !== valuation_type){
          const rules = Object.assign({},RULES(this))
          const filterRules = Object.keys(rules).reduce((acc,key)=>{
            if(key !='weight'){
              acc[key] = rules[key]
            }
            return acc
          },{})
        this.rules = filterRules
      } else {
        this.rules = Object.assign({},RULES(this))
      }
      this.$set(this.shipsTemplate, shopId, list);
      this.$refs.form.clearValidate()
      this.validPage()
    },
    handleSelectRetailShopCategory(shopData) {
      const { userId } = shopData;
      this.retailShopId = userId;
      const { shopCategoryMap } = this.self_form;
      // 初始化值
      if (!shopCategoryMap[userId]) {
        this.$set(shopCategoryMap, userId, {
          userId,
          categoryId: null,
          categoryName: null,
        })
      }
      const matchData = shopCategoryMap[userId];
      this.$refs.selectRetailShopCategoryDialog.handleShow(userId, cloneDeep(matchData));
    },
    handleSelectRetailShopCategoryCallback(selectData = {}) {
      const userId = this.retailShopId;
      this.self_form.shopCategoryMap[userId] = selectData;
      this.$refs.form.validateField(`shopCategoryMap.${userId}.categoryId`);
    },
    useGroupImages(data, type) {
      const {mainImages=[], detailImages=[], speImages=[]} = data
      let pic = [], description = [];
      if(type === 'add') {
        pic = [...this.self_form.images].filter(Boolean)
      }
      if(mainImages.length) {
        this.self_form.images = [...pic, ...mainImages].filter(Boolean).slice(0, 50)
      }
      const firstSpec = this.specifications[0];
      if (firstSpec && firstSpec.values && speImages.length) {
        firstSpec.values.forEach(specValue => {
          // 如果是新增模式且已有图片，则跳过
          if (type === 'add' && specValue.imageUrl) {
            return;
          }
          
          // 查找匹配的图片
          const matchedImage = speImages.find(img => img.name === specValue.value);
          if (matchedImage) {
            specValue.imageUrl = matchedImage.imgUrl;
          }
        });
      }
    },
    getGroupImagesList (list){
      this.showGroupImages = !!list?.length
    },
    editGroupImages(){
      this.changeToBase('openGroupImgs')
    },
    getSkuTableCols(){
      let openSource = this.openSource
      let isShowPreviewPrice = true;
      if(['taskCenter','previewPublish'].includes(openSource)){
          isShowPreviewPrice = false
      }
      let cols = [
        {
          prop: "skuPrice",
          attrs: { label: "价格" },
          input: { type: "number", validator: validateSkuPrice },
          previewPrice: isShowPreviewPrice, previewPriceType: 'sales'
        },
        { prop: 'skuSupplyPrice', attrs: { label: '供货价',noRequired:true },unvisible:JSON.parse(localStorage.getItem('_origin_form'))?.isDistribution == 0 ? true : false  },
        {
          prop: "stockNum",
          attrs: { label: "库存" },
          input: { type: "number", validator: validateSkuStock },
          disabledFn: (row) => {
            return (this.form?.pureType || row.stockType === 1)
          },
        },
        {
          prop: "weight",
          attrs: { label: "重量(kg)" },
          input: { type: "number"},
        },
        this.openSource != 'shopGoods' ? { prop: "skuOuterId", attrs: { label: "商家编码" } } : null,
      ]
      this.skuTableCols = cols.filter(Boolean);
    }
  },
  created(){
    this.getSkuTableCols();
  }
};
</script>

<style lang="scss" scope>
.flex-column {
  display: flex;
  flex-direction: column;
  & > * {
    margin-bottom: 5px;
  }
}
.retail-wrapper{
  font-size: 0;
  .label-wrap{
    width: 12%;
    display: inline-block;
    height: 26px;
  }
  .form-wrap{
    width: 88%;
    display: inline-block;
    .shop-wrap{
      display: inline-block;
      height: 26px;
      ::v-deep .el-image{
        vertical-align: middle;
      }
      .shop-title{
        vertical-align: top;
        height: 26px;
        line-height: 26px;
        display: inline-block
      }
    }
    .category-wrap{
      display: inline-block;
      height: 26px;
      line-height: 26px;
      vertical-align: top;
    }
  }
}
.pt-5 {
  padding-top: 5px;
}
.mb-5 {
  margin-bottom: 5px;
}
.platform-info-edit-wrp {
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>